




















import Vue from 'vue'
import Component from 'vue-class-component'
import {
    AtomSpinner,
    FlowerSpinner,
    PixelSpinner,
    HollowDotsSpinner,
    IntersectingCirclesSpinner,
    RadarSpinner,
    ScalingSquaresSpinner,
    HalfCircleSpinner,
    TrinityRingsSpinner,
    FulfillingSquareSpinner,
    CirclesToRhombusesSpinner,
    SemipolarSpinner,
    SelfBuildingSquareSpinner,
    SwappingSquaresSpinner,
    FulfillingBouncingCircleSpinner,
    FingerprintSpinner,
    SpringSpinner,
    LoopingRhombusesSpinner,
    BreedingRhombusSpinner,
} from 'epic-spinners'
import FlagSpinner from '@/components/spinners/FlagSpinner.vue'
import { detect, BrowserName, BrowserInfo } from 'detect-browser'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {Prop} from 'vue-property-decorator'

/**
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        AtomSpinner,
        FlowerSpinner,
        PixelSpinner,
        HollowDotsSpinner,
        IntersectingCirclesSpinner,
        RadarSpinner,
        ScalingSquaresSpinner,
        HalfCircleSpinner,
        TrinityRingsSpinner,
        FulfillingSquareSpinner,
        CirclesToRhombusesSpinner,
        SemipolarSpinner,
        SelfBuildingSquareSpinner,
        SwappingSquaresSpinner,
        FulfillingBouncingCircleSpinner,
        FingerprintSpinner,
        SpringSpinner,
        LoopingRhombusesSpinner,
        BreedingRhombusSpinner,
        FlagSpinner,
    },
})
export default class Loader extends Vue {
    /**
     * Controla la visibilidad del cargador
     */
    @Prop({type: Boolean, default: false})
    public value: boolean
    public spinners = [
        // { component: 'AtomSpinner'},
        { component: 'FlowerSpinner', skipInChrome: false},
        { component: 'PixelSpinner', skipInChrome: false},
        // { component: 'HollowDotsSpinner'},
        // { component: 'IntersectingCirclesSpinner'},
        // { component: 'RadarSpinner' },
        // { component: 'ScalingSquaresSpinner'},
        // { component: 'HalfCircleSpinner'},
        // { component: 'TrinityRingsSpinner'},
        // { component: 'FulfillingSquareSpinner'},
        // { component: 'CirclesToRhombusesSpinner'},
        // { component: 'SemipolarSpinner'},
        // { component: 'SelfBuildingSquareSpinner'},
        // { component: 'SwappingSquaresSpinner'},
        // { component: 'FulfillingBouncingCircleSpinner'},
        // { component: 'FingerprintSpinner'},
        { component: 'SpringSpinner', skipInChrome: false},
        // { component: 'LoopingRhombusesSpinner'},
        // { component: 'BreedingRhombusSpinner'},
        // { component: 'FlagSpinner'},
    ]

    public currentSpinner: KeyValuePair | null
    public readonly browser = detect()

    public randomSpinner () {
        const browserName = (this.browser as BrowserInfo).name
        let spinner = this.spinners[Math.floor(Math.random() * this.spinners.length)];
        do {
            spinner = this.spinners[Math.floor(Math.random() * this.spinners.length)];
        } while (browserName === 'chrome' && spinner.skipInChrome)

        this.currentSpinner = spinner
    }

    public created () {
        this.randomSpinner()
    }
}
